import { skipToken, useQuery } from "@tanstack/react-query";
import api from "../../../../../../../api";
import urls from "../../../../../../../urls";
import { queryWithPollResponse } from "../../../../../../../utils/api-utils";
import type { BatchImportError } from "../types";

function useValidateBatchTemplate(template: File | undefined) {
  const { data, isLoading, error } = useQuery({
    queryKey: [
      "mieterstrom-batch-import-validation",
      { template, template_name: template?.name, template_size: template?.size }
    ],
    queryFn: template ? () => fetchValidationResult(template) : skipToken,
    refetchInterval: false
  });

  return { data, isLoading, error };
}

async function fetchValidationResult(template: File) {
  const formData = new FormData();
  formData["formDataObject"] = { excel: template };

  const response = await queryWithPollResponse<Array<BatchImportError>>(
    () => api.post(urls.api.mieterstromBatchImport.dispatchCheck(), formData),
    {
      queryAgainOnPollSuccess: true,
      queryAgainOnPollSuccessWithTaskId: true,
      queryAgainFn: (taskId?: string) =>
        taskId
          ? api.get(urls.api.mieterstromBatchImport.fetchCheck(taskId))
          : Promise.reject(new Error("taskId is required"))
    }
  );

  return response.data;
}

export { useValidateBatchTemplate };
